const Fonts = {
NunitoSans: 'Nunito, sans-serif', // Ensure this matches the font family loaded
  Montserrat: 'Montserrat, sans-serif',
  Poppins: 'Poppins, sans-serif',
};


export default Fonts
